// Identisch zu user Goal settings / commitment settings ?
// oder mischung aus beidem?

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {},
  staticActions: {},

  schema: {
    create({ prioidx, cachedName }, data) {
      return {
        cachedName:             cachedName,
        prioidx:                prioidx,
        sortidx:                data.sortidx || 1,
        timeslotCollectionId:   data.timeslotCollectionId || '',
        graphicalRepresentation: {
          fontFamily:   "Roboto",
          fontSize:     15,
          fill:         '#ffffff',
          show:         data.show === undefined ? true : data.show,
        },
      };
    },

    fields: {
      cachedName: {},
      prioidx: {},
      sortidx: {},
      timeslotCollectionId: {},
      graphicalRepresentation: { validate_bolt_type: 'ChallengeGraphicalRepresentation' },
      'graphicalRepresentation/fontFamily': {},
      'graphicalRepresentation/fontSize': {},
      'graphicalRepresentation/fill': {},
      'graphicalRepresentation/show': {},
    }
  }
};
